import {
    container,
    title,
    main,
    mainRaised,
    mlAuto,
    description,
    dashed
} from "../../material-kit-pro-react.jsx";

import customCheckboxRadioSwitchStyle from "../../material-kit-pro-react/customCheckboxRadioSwitchStyle.jsx";
import customSelectStyle from "../../material-kit-pro-react/customSelectStyle.jsx";

const bookingStyle = {
    main,
    mainRaised,
    title,
    mlAuto,
    description: {
        ...description,
        maxWidth: "150px"
    },
    ...customSelectStyle,
    ...customCheckboxRadioSwitchStyle,
    container: {
        ...container,
        maxWidth: "970px !important"
    },
    contactContent: {
        paddingBottom: "40px",
        paddingTop: "40px"
    },
    bigMap: {
        height: "55vh",
        maxHeight: "550px",
        width: "100%",
        display: "block"
    },
    info: {
        paddingBottom: "10px",
        paddingTop: 0
    },
    textCenter: {
        textAlign: "center !important"
    },
    block: {
        color: "inherit",
        padding: "0.9375rem",
        fontWeight: "500",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        position: "relative",
        display: "block"
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto"
    },
    list: {
        marginBottom: "0",
        padding: "0",
        marginTop: "0"
    },
    left: {
        float: "left!important",
        display: "block"
    },
    right: {
        padding: "15px 0",
        margin: "0",
        float: "right"
    },
    productPage: {
        backgroundColor: "#eee",
        "& $mainRaised": {
            margin: "-40vh 0 0",
            padding: "40px"
        },
        "& .image-gallery-slide img": {
            borderRadius: "3px",
            maxWidth: "500px",
            height: "auto"
        },
        "& .image-gallery-swipe": {
            margin: "30px 0px",
            overflow: "hidden",
            width: "100%",
            height: "auto",
            textAlign: "center"
        },
        "& .image-gallery-thumbnails > .image-gallery-thumbnails-container a": {
            "&.active > div": {
                opacity: "1",
                borderColor: "#DDDDDD"
            },
            "& > div": {
                width: "80%",
                maxWidth: "85px",
                margin: "0 auto",
                padding: "8px",
                display: "block",
                border: "1px solid transparent",
                background: "transparent",
                borderRadius: "3px",
                opacity: ".8"
            },
            "& > div img": {
                borderRadius: "3px",
                width: "100%",
                height: "auto",
                textAlign: "center"
            }
        }
    },
    pageHeader: {
        minHeight: "70vh",
        maxHeight: "1000px",
        height: "auto",
        backgroundPosition: "top center"
    },
    icon: {
        width: "18px",
        height: "18px",
        top: "3px",
        position: "relative"
    },
    actionButton: {
        margin: "0px",
        padding: "5px",
        color: "red"
    },
    clarificationQuote: {
        marginTop: "40px",
        marginBottom: "40px",
        color: "red"
    },
    hidden: {
        display: "none"
    },
    errorDisplay: {
        color: "red"
    },
    textRight: {
        textAlign: "right"
    },
    tdNameSmall: {
        fontSize: "0.75em",
        fontWeight: "500"
    },
    customFont: {
        fontSize: "16px !important"
    },
    tdNumber: {
        textAlign: "right",
        minWidth: "150px",
        fontWeight: "300",
        fontSize: "1.125em !important"
    },
    tdNumberAndButtonGroup: {
        lineHeight: "1 !important",
        "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
            marginRight: "0"
        }
    },


    dashed,
    totalPrice: {
        fontSize: "22px"
    }
};

export default bookingStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-pro-react/views/bookingStyle.jsx